import { useRef, useState } from "react";
import { modifyMediaUrl } from "../helpers/modifyMediaUrl";
import { useEffect } from "react";
import { getSampleLessonsData } from "../services/homePageService";
import { HOME_PAGE_CONSTANTS } from "../constants/app-constants";
import { i18n, initializeI18n } from "../localization/i18n";
import VODPlayer from "./vod/VodPlayer";
import { getVODInformation } from "../services/courseService";

export default function SampleLessonSection({ props }) {
  const [sampleLessonList, setSampleLessonList] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState(null);
  const [showVideoOverlay, setShowVideoOverlay] = useState(true);
  const videoRef = useRef(null);

  const [playingVOD, setPlayingVOD] = useState(null);

  const [firstLesson, ...restLesson] = sampleLessonList;

  // const handlePlayVideo = () => {
  //   if (videoRef.current) {
  //     setShowVideoOverlay(false);
  //     videoRef.current.play();
  //   }
  // };

  const handleClickVideoItem = (id) => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      videoRef.current.load();
    }
    // setShowVideoOverlay(true);
    const copiedLessonList = JSON.parse(JSON.stringify(sampleLessonList));
    const selectedVideoIndex = copiedLessonList?.findIndex((item) => item?.id === id);
    if (selectedVideoIndex !== -1) {
      const [selectedVideo] = copiedLessonList?.splice(selectedVideoIndex, 1);
      copiedLessonList.unshift(selectedVideo);
      setSampleLessonList(copiedLessonList)
      loadVideoForPlaying(selectedVideo.publicId)
    }
  };

  useEffect(() => {
    const fetchSampleLessonsData = async () => {
      const data = await getSampleLessonsData({ quantity: HOME_PAGE_CONSTANTS.GET_SAMPLE_LESSON_QUANTITY });
      setSampleLessonList(data);
      if (data.length > 0) {
        loadVideoForPlaying(data[0].publicId)
      }
    };
    fetchSampleLessonsData();
  }, []);

  const loadVideoForPlaying = (publicId) => {
    try {
      if(publicId)
        getVODInformation(publicId).then((vod) => {
          setPlayingVOD(vod);
        })
    } catch (error) {
      setPlayingVOD(null);
    }
  }


  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => {
        setCurrentLanguage(i18n.language);
      });
    } else {
      setCurrentLanguage(i18n.language);
    }
  }, []);


  return (
    <div className="sample-lesson-section" data-aos="fade-down" data-aos-duration="1000">
      <div className="sample-lesson-title text-center mx-2">
        <h1 className="text-primary-txt-color line-height-57 text-6xl font-semibold mt-0 animate-on-scroll">{props?.sampleLessonSectionTitle1}</h1>
        <h4 className="text-2xl font-normal line-height-32 my-0 animate-on-scroll">{props?.sampleLessonSectionTitle2}</h4>
      </div>
      <div className="sample-lesson-video-wrapper grid width-limited flex gap-5 mt-6">
        <div className="main-video col-12 lg:col-9 flex-1 relative animate-on-scroll">

          <div className="vod-information-wrapper">
            <div className="video-player-wrapper" style={{ backgroundColor: 'black' }}>
              {playingVOD && playingVOD.resourceUrl && (
                <VODPlayer
                  resourceUrl={modifyMediaUrl(playingVOD.resourceUrl)}
                />
              )}
            </div>
            {/* 
              {showVideoOverlay && (
                <div className="main-video-overlay absolute h-full w-full">
                  <div className="relative h-full w-full">
                    <div className="play-icon absolute h-full w-full flex justify-content-center align-items-center">
                      <button className="border-none cursor-pointer" onClick={handlePlayVideo}>
                        <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" width="64" height="64" rx="32" fill="white" />
                          <path
                            d="M52.0741 30.5068L20.5792 11.2593C20.3139 11.0972 20.0103 11.0087 19.6994 11.0029C19.3886 10.997 19.0818 11.0741 18.8107 11.2262C18.5395 11.3783 18.3137 11.5999 18.1566 11.8681C17.9995 12.1364 17.9167 12.4417 17.9167 12.7526V51.2476C17.9167 51.5585 17.9995 51.8638 18.1566 52.132C18.3137 52.4003 18.5395 52.6219 18.8107 52.7739C19.0818 52.926 19.3886 53.0031 19.6994 52.9973C20.0103 52.9915 20.3139 52.9029 20.5792 52.7408L52.0741 33.4933C52.3299 33.337 52.5413 33.1176 52.6879 32.8561C52.8345 32.5946 52.9116 32.2999 52.9116 32.0001C52.9116 31.7003 52.8345 31.4055 52.6879 31.1441C52.5413 30.8826 52.3299 30.6632 52.0741 30.5068Z"
                            fill="#3054F1"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="absolute bottom-0 left-0 margin-bottom-12 px-4">
                      <h3 className="text-white font-semibold m-0">{firstLesson?.title}</h3>
                    </div>
                  </div>
                </div>
              )} */}
          </div>

        </div>
        <div className="list-video-wrapper col-12 lg:col-3 mx-2">
          <div className="list-video flex flex-column gap-3">
            {restLesson?.map((lesson, index) => (
              <button key={index} className="border-none cursor-pointer bg-white p-0" onClick={() => handleClickVideoItem(lesson?.id)}>
                <div className="list-video-item relative w-full h-full">
                  <img src={modifyMediaUrl(lesson?.thumbnailImage)} alt="lesson-item-thumbnail-image" />
                  <div className="list-video-overlay absolute h-full w-full">
                    <div className="relative h-full w-full">
                      <div className="play-icon-wrapper flex justify-content-between align-items-center absolute w-full bottom-0 p-2">
                        <h6 className="text-base lg:text-xl font-normal text-white m-0 textfont-semibold">{lesson?.title}</h6>
                        <div className="play-icon flex justify-content-between align-items-center">
                          <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" width="32" height="32" rx="16" fill="white" />
                            <path
                              d="M24.8889 15.3601L11.3911 7.11114C11.2774 7.04166 11.1473 7.00372 11.014 7.00123C10.8808 6.99874 10.7493 7.03177 10.6331 7.09695C10.5169 7.16212 10.4202 7.25708 10.3528 7.37205C10.2855 7.48702 10.25 7.61786 10.25 7.7511V24.249C10.25 24.3822 10.2855 24.513 10.3528 24.628C10.4202 24.743 10.5169 24.8379 10.6331 24.9031C10.7493 24.9683 10.8808 25.0013 11.014 24.9988C11.1473 24.9963 11.2774 24.9584 11.3911 24.8889L24.8889 16.64C24.9985 16.573 25.0891 16.479 25.152 16.3669C25.2148 16.2548 25.2478 16.1285 25.2478 16C25.2478 15.8716 25.2148 15.7452 25.152 15.6332C25.0891 15.5211 24.9985 15.4271 24.8889 15.3601Z"
                              fill="#3054F1"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
          <a href={`/${currentLanguage}/vod`} className="no-underline">
            <button className="py-3 px-5 mt-3 w-full bg-buttons-primary text-white text-xl font-semibold line-height-28 border-none sample-lesson-action-btn cursor-pointer">
              {props?.sampleLessonSectionButtonLabel}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
